import React from 'react';
import { Config } from '../../Types';
export interface AppConfig extends Config {
  defaultSourceId?: string;
}

export const defaultAppConfig: Config = {
  callAttemptAmount: 3,
  callAttemptInterval: 5,
  incidentReporterOnWatchlist: 'false',
  colorSchemeBackground: '#ffffff',
  colorSchemePrimary: '#2D4145',
  colorSchemeSecondary: '#6AC2CC',
  createdAt: new Date(),
  updatedAt: new Date(),
  id: '',
  workHoursFrom: (process.env.WORKHOURS_FROM as string) ?? '07:00',
  workHoursUntil: (process.env.WORKHOURS_UNTIL as string) ?? '18:00',
  incidentCreatedEmailTemplateId: '9bb2ece0-7665-480f-8f0a-f1136f4f1645',
  incidentUpdatedEmailTemplateId: '7a361a37-f92a-4e1a-a406-83f635ff26c2',
  taskCreatedEmailTemplateId: '5d4c74a7-67eb-4bcc-90ce-d96d027efbcf',
  taskUpdatedEmailTemplateId: '359668cf-42d5-4e16-9e9d-5b25b460aaa9',
  taskRemindedEmailTemplateId: '355702df-329f-48e8-b8d8-6a621d73f7ee',
  taskDoneEmailTemplateId: '7c183401-c69f-4832-88c5-51344cc4ece0',
  incidentMentionEmailTemplateId: 'dda82e7f-067f-4a97-a2ba-e534f750ce21',
  crisisRoomMentionEmailTemplateId: '1430889c-9ecc-4c24-a180-ca5ce336a69b',
  primaryLanguageId: 'primaryLanguageId',
  notTranslatableLanguages: 'HR|SR',
  easyShareUrl: '',
  conducttrUrl: '',
  incompleteIncident: { deleteAfterMinutes: null },
  map: {
    lat: 52,
    lon: 9,
    zoom: 8,
    token: '',
  },
};

export const AppConfigContext =
  React.createContext<AppConfig>(defaultAppConfig);
